import {mapActions, mapGetters, mapMutations} from "vuex";
import mainButton from '@/components/main-button/index.vue'
import gallery from './components/gallery-product/index.vue';
import productSlider from '@/components/slider/index.vue'

export default {
    name: 'card',
    data() {
        return {
            delivery: false,
            description: true,
            metaName: '',
            metaDescription: '',
            metaKeywords: '',
            metaProductName: '',
            test: '',
            attr: {},
            payload: {
                user_name: "",
                user_phone: "",
                product: ""
            },
            count: 0
        }
    },

    metaInfo() {
        return {
            title: (this.metaName ? this.metaName : this.metaProductName) + ' | Eco-store',
            meta: [
                {property: 'description', content: this.metaDescription, id: 'description'},
                {property: 'keywords', content: this.metaKeywords, id: 'keywords'},
                {property: 'og:title', content: this.metaName, id: 'og:title'},
                {property: 'og:description', content: this.metaDescription, id: 'og:description'},
            ]
        }
    },

    components: {
        mainButton,
        gallery,
        productSlider
    },
    methods: {
        ...mapActions({
            fetchProduct: 'card/PRODUCT_DATA',
            fetchPopularProducts: 'card/POPULAR_PRODUCTS',
            fastBay: 'order/FAST_BUY',
            gatUserData: 'userData/GET_DATA'
        }),
        ...mapMutations({
            changeShowPopUpFastOrder: 'order/FAST_ORDER',
            addToBasket: 'order/ADD_BASKET'
        }),

        checked() {
            this.delivery = !this.delivery
            this.description = !this.description
        },
        addBasket() {
            this.addToBasket({
                count: this.count,
                ...this.productData
            })
            this.$toasted.success(this.$t('productAddedIntoBasket') );
        }

    },
    computed: {
        ...mapGetters({
            productData: 'card/productData',
            productAttributes: 'card/productAttributes',
            popularProducts: 'card/popularProducts',
            isAuthenticated: 'auth/isAuthenticated',
            userInfo: 'userData/userInfo',
            getCurrentOrder: 'order/getCurrentOrder',
        })
    },

    created() {
        // this.gatUserData()
        this.fetchProduct({slug: this.$route.params.slug}).then(() => {
            this.metaName = this.productData.meta.name,
                this.metaDescription = this.productData.meta.description,
                this.metaKeywords = this.productData.meta.keywords
            this.metaProductName = this.productData.name
        })
        this.fetchPopularProducts({slug: this.$route.params.slug})


    },
    watch: {
        '$route'() {
            this.fetchProduct({slug: this.$route.params.slug})
            this.fetchPopularProducts({slug: this.$route.params.slug})
        }

    }
}
